import * as Yup from "yup";
import { FormGroup } from "../../../components/form";

export const kindergartenForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      fieldType: "value",
      key: "isInternal",
      calculatedValue: () => true,
    },
    {
      type: "field",
      key: "lga",
      fieldType: "input",
      label: "LGA the kindergarten is located in",
      props: {
        disabled: true,
      },
    },
    {
      type: "field",
      key: "fundedKinderName",
      fieldType: "input",
      label: "Name of the kindergarten service lodging this application",
      props: {
        disabled: true,
      },
    },
    {
      type: "field",
      key: "kindergartenNameOther",
      fieldType: "input",
      label: "Please enter the name of the kindergarten",

      props: {
        disabled: true,
      },
    },
    {
      type: "field",
      key: "contactNumber",
      fieldType: "input",
      label: "Phone number",
      props: {
        disabled: true,
      },
    },
    {
      type: "field",
      key: "kindergartenAddressDetails",
      fieldType: "search",
      label: "Kindergarten physical address",
      props: {
        apiPath: "GooglePlaces/GetAutoCompleteSuggestions",
        placeholder: "Kindergarten physical address",
        labelValue: "address",
        displayField: "address",
      },
      validation: Yup.object().required("A response is required."),
    },
    {
      type: "field",
      key: "contactEmail",
      fieldType: "input",
      label: "Kindergarten email address",
      validation: Yup.string()
        .required("A response is required")
        .matches(RegExp("^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$"), { message: "Please enter a valid email address" }),
    },
    {
      type: "field",
      fieldType: "radio",
      key: "kindergartenProgram",
      label: "What type of program is offered by the kindergarten service?",
      validation: Yup.string().required("A response is required"),
      props: {
        options: [
          {
            label: "Sessional",
            value: 1,
          },
          {
            label: "Long day care",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      fieldType: "radio",
      key: "isEymOrganisation",
      label: "Is the kindergarten service administered by an Early Years Management (EYM) organisation?",
      hideExpression(formContext, values, model) {
        return model.kindergartenProgram != 1;
      },
      validation: Yup.string().required("A response is required"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      key: "eymName",
      fieldType: "input",
      label: "Please provide the name of the EYM organisation",
      hideExpression(formContext, values, model) {
        return model.isEymOrganisation != 1 || model.kindergartenProgram != 1;
      },
      validation: Yup.string().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "radio",
      key: "eymAuthorisation",
      label: "I confirm that the EYM organisation is aware of and has authorised the submission of this application",
      extendedlabel:
        "The EYM must agree to and authorise the submission of the application. By ticking Yes, you confirm this has occurred and are making a declaration that you have this approval. Failure to have completed this step may result in the withdrawal of this application.",
      hideExpression(formContext, values, model) {
        return model.isEymOrganisation != 1 || model.kindergartenProgram != 1;
      },
      validation: Yup.string()
        .required("A response is required")
        .matches(
          /1/,
          "The application cannot be submitted without the authorisation of the EYM organisation. Please save the application, and resume the application after the EYM has authorised the submission of this application."
        ),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      key: "eymRepName",
      fieldType: "input",
      label: "Please provide the name of the EYM representative that authorised the submission of this application",
      hideExpression(formContext, values, model) {
        return model.isEymOrganisation != 1 || model.kindergartenProgram != 1;
      },
      validation: Yup.string().required("A response is required"),
    },
    {
      type: "field",
      key: "eymRepEmail",
      fieldType: "input",
      label: "Please provide the email address of the EYM representative that authorised the submission of this application",
      hideExpression(formContext, values, model) {
        return model.isEymOrganisation != 1 || model.kindergartenProgram != 1;
      },
      validation: Yup.string()
        .required("A response is required")
        .matches(RegExp("^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$"), { message: "Please enter a valid email address" }),
    },
  ],
};
